function readmore(button) {
  var shortDescription = button.previousElementSibling;
  var collect_short_info = document.querySelector(".collection-short-info");
  var readArrow = button.querySelector('.readArrow');
  if (shortDescription.classList.contains('expanded')) {
    shortDescription.classList.remove('expanded');
    collect_short_info.classList.remove('active');
    button.querySelector('.readText').innerText = 'Read More';
    readArrow.classList.remove('rotated');
  } else {
    shortDescription.classList.add('expanded');
    collect_short_info.classList.add('active');
    button.querySelector('.readText').innerText = 'Read Less';
    readArrow.classList.add('rotated');
  }
}

/**collection filter for mobile view**/
function handleFilterClick() {
const filterDrawer = document.getElementById('filter_drawer');

  if (filterDrawer) {
    filterDrawer.click(); // Simulate a click on the filter_drawer button
  } else {
    //console.error('filter_drawer element not found!');
  }
}
console.log('venkatesh')